export default [
  {
    path: "/cadastre-se",
    name: "SignUp",
    beforeEnter: (to, from, next) => {
      if (to && to.query && to.query.plan_code) {
        next()
      } else {
        next({ name: 'error404' })
      }
    },
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/cadastre-se/:planCode",
    name: "SignUpParameter",
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/signup-simple/",
    name: "SignUpSimple",
    meta: {
      simple: true
    },
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/signup-simple/:planCode",
    name: "SignUpSimpleParameter",
    meta: {
      simple: true
    },
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/confirmacao-pedido",
    name: "PaymentConfirmation",
    component: () =>
      import("@/views/PaymentConfirmation/PaymentConfirmation.vue"),
  },
  {
    path: "/signup-simple-finalization",
    name: "SignUpSimpleFinalization",
    meta: {
      simple: true
    },
    component: () => import("@/views/PaymentConfirmation/PaymentConfirmation.vue"),
  },
  {
    path: "/rede-credenciada",
    name: "AccreditedNetwork",
    component: () => import("@/views/AccreditedNetwork/AccreditedNetwork.vue"),
  },
  {
    path: '/doctors-results-not-found',
    name: 'doctors-results-not-found',
    component: () =>
      import('@/views/errors/doctors-results-not-found.vue')
  },
  {
    path: '*',
    name: 'error404',
    component: () =>
      import('@/views/errors/error404.vue')
  },
]
